import React from 'react';
import './footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2023 BhushanPortfolio. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
